import classes from './Element.module.css'
import ConditionPin from './ConditionPin'

function GoNoGo (props) {

    function getTextWidth(text, font) {
        // Create a canvas element
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        
        // Set the font for the context
        context.font = font;
        
        // Measure the width of the text
        const width = context.measureText(text).width;
        
        // Return the width
        return width;
    }

    // let num_input = props.maxArr; //factors.length;
    let num_pins = props.max_num_pins;
    let height_pin_full = 35;
    let minHeight = 170;
    let height_gonogo = (num_pins+1.25)*height_pin_full;
    height_gonogo =height_gonogo.toString() + 'px';
    minHeight = minHeight.toString() + 'px';


    let all_conditions = (<></>);
    let remove_conditions = (<></>);
    if (props.element.pins) {
        // let max_length_pinname = Math.max(props.element.pins.reduce((max, pin) => Math.max(max, getTextWidth(pin.name, '14px Roboto')), 0), getTextWidth('Factor', '14px Roboto')) ;
        let max_length_pinname = Math.max(props.element.pins.reduce((max, pin) => Math.max(max, getTextWidth(pin.name, '14px Roboto')), 0), 60) ;
        all_conditions = props.element.pins.map((pin, pinIndex) => (
            <ConditionPin id={props.elem_id+'_'+pinIndex} 
                       key={props.elem_id+'_'+pinIndex} 
                       name={pin.name}
                       max_length_pinname={max_length_pinname}
                       handleEnter={props.handlePinName}/>
        ));
   
        remove_conditions = props.element.pins.map((pin, pinIndex) => (
                <div key={props.elem_id+'_'+pinIndex} className={classes.container_remove_pin} style={{height: height_pin_full}}>
                    <button key={props.elem_id+'_'+pinIndex} id={'delete_condition_'+props.elem_id+'_'+pinIndex} onClick={props.handleRemovePin} className={classes.remove_pin_button} >-</button>
                </div>
        ));
    }

    let move_block = (<>
                        <button id={'move_left_'+props.elem_id} onClick={props.handleMoveLeft} className={classes.move_left} style={{marginRight:'100px', marginTop:'14px'}} /> 
                        <div style={{position:'relative', fontSize:'14px', height:'fit-content', marginLeft:'10px', marginRight:'10px', marginTop:'0px', marginBottom:'0px', paddingBottom:'0px', top:'50%', transform: 'translate(0%,-50%)'}} >move block</div>
                        <button id={'move_right_'+props.elem_id} onClick={props.handleMoveRight} className={classes.move_right} style={{marginLeft:'100px', marginTop:'14px'}} />
                    </>);

    if(props.isFirstElement){
        move_block = (<>
                        <div style={{position:'relative', fontSize:'14px', height:'fit-content', marginLeft:'10px', marginRight:'10px', marginTop:'0px', marginBottom:'0px', paddingBottom:'0px', top:'50%', transform: 'translate(0%,-50%)'}} >move block</div>
                        <button id={'move_right_'+props.elem_id} onClick={props.handleMoveRight} className={classes.move_right} style={{marginLeft:'100px', marginTop:'14px'}} />
                    </>);
    }

    if(props.isLastElement){
        move_block = (<>
                        <button id={'move_left_'+props.elem_id} onClick={props.handleMoveLeft} className={classes.move_left} style={{marginRight:'100px', marginTop:'14px'}} /> 
                        <div style={{position:'relative', fontSize:'14px', height:'fit-content', marginLeft:'10px', marginRight:'10px', marginTop:'0px', marginBottom:'0px', paddingBottom:'0px', top:'50%', transform: 'translate(0%,-50%)'}} >move block</div>
                    </>);
    }
    if (props.isLastElement && props.isFirstElement){ 
        move_block=(<></>);
    }

    return (
        <>

            <div id='outer container' className={classes.outer_container} >
                <div id='condition container' className={classes.pin_container} style = {{height: height_gonogo, minHeight: minHeight}}>
                    {all_conditions}
                </div>

                <div id='gonogo container out' className={`${classes.color_block_container} ${classes.blue}`}>
                    <div id='gonogo container' className={classes.upper_container} style ={{height: height_gonogo, minHeight: minHeight}}>
                        <div id='action_panel' className={classes.action_panel} >
                            {remove_conditions}
                            <button id={'add_condition_'+props.elem_id} onClick={props.handleAddPin} className={classes.plus_button}  style={{top:'1px'}}>+</button>
                        </div>
                        <div id='main container' className={classes.upper_container_main}>
                            <button id={'delete_gonogo_'+props.elem_id} onClick={props.handleDelete} className={classes.plus_button}  style={{left:'136px'}}>x</button>
                            <div style={{height: '30px'}}></div>
                            <textarea id={'element_name_'+props.elem_id} value = {props.element.name} autoComplete='false' placeholder ='Go/NoGo Step' onChange={props.handleEnterName} className={classes.textarea} />
                        </div>
                    </div>
                    <div className={classes.block_name}>Go/NoGo</div>
                    <div id='footer_container' className={classes.footer_container}>
                        {move_block}
                    </div>
                </div>
            </div>
        </>);
     }


export default GoNoGo;